/*
 * @Author: zhb 1822394027@qq.com
 * @Date: 2022-10-05 11:21:08
 * @LastEditors: zhb 1822394027@qq.com
 * @LastEditTime: 2022-10-05 11:58:47
 * @FilePath: \huayue\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App.vue';
import Element from 'element-ui';
import router from './router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueCoreVideoPlayer from 'vue-core-video-player';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/font/font.css';
import 'swiper/css/swiper.min.css';

import AppBar from '@/components/appbar-wrap.vue';
import FootWrap from '@/components/foot-wrap.vue';
import RightFixedgt from '@/components/right-fixedgt.vue';
import AltProduct from '@/components/alt-product.vue';
import ast from '@/components/ast.vue'
Vue.config.productionTip = false;

Vue.use(Element);
Vue.use(VueAwesomeSwiper);
Vue.use(VueCoreVideoPlayer, {
  lang: 'zh-CN',
});
Vue.component('AppBar', AppBar);
Vue.component('FootWrap', FootWrap);
Vue.component('RightFixedgt', RightFixedgt);
Vue.component('AltProduct', AltProduct);
Vue.component('ast', ast)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
